export class DeleteInputValue {
    constructor(optionalOptions = {}) {
        this._inputs = document.querySelectorAll('.base-input-wrp');

        if (!this._inputs) {
            this.destructor();
            return true;
        }

        let inputButton

        this._inputs.forEach((input) => {
            inputButton = input.querySelector('.base-input--icon');

            if (inputButton) {
                inputButton.addEventListener("click", (event) => {
                    event.preventDefault()

                    if (input.classList.contains('success')) {
                        return false;
                    }

                    if (input.classList.contains('input-password')) {
                        if (input.querySelector('input').type === "password") {
                            input.querySelector('input').type = "text";
                        } else {
                            input.querySelector('input').type = "password";
                        }

                        return false
                    }

                    input.classList.remove('error')
                    input.querySelector('input').value = "";
                    input.querySelector('input').dispatchEvent(new Event('change'));

                    return false
                })
            }
        })
    }

    destructor() {
        this._inputs = null;
    }
}

export default new DeleteInputValue();